import React from 'react';

import style from './index.scss';

const HeaderPanel = ({ data }) => {
  return (
    <div className={style.headerCounterPanelContainer}>
      <p className={style.counterValue}>{data.valueText}</p>
      <p className={style.counterLabel}>{data.labelText}</p>
    </div>
  );
};

export default HeaderPanel;
